module.exports = __webpack_public_path__ + "img/Monte_Kope_35.2bab50a4.jpg";